import React from 'react';
import PciRouter from './components/pci-router/PciRouter';

const App = (): JSX.Element => {
    return <PciRouter />;
};

export default App;
